
export default function BlogHero() {
  return (
    <section 
      className="relative bg-cover bg-center py-24 px-4"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://public.readdy.ai/ai/img_res/3108efe6bcc607fcce705b0c31641881.jpg')`
      }}
    >
      <div className="max-w-6xl mx-auto text-center text-white">
        <h1 className="text-5xl md:text-6xl font-bold mb-6">
          Soccer Insights & Tips
        </h1>
        <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">
          Expert advice, training tips, and the latest news from NextZen Soccer Academy. Improve your game with insights from our professional coaches.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button className="bg-purple-600 hover:bg-purple-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
            Latest Posts
          </button>
          <button className="border-2 border-white text-white hover:bg-white hover:text-gray-900 px-8 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
            Subscribe to Newsletter
          </button>
        </div>
      </div>
    </section>
  );
}
